import { routingPaths } from "./types";

export const buildRoutingPath = (
  path: routingPaths,
  params: {
    fromId?: string;
    toId?: string;
    floorName?: string;
  },
) => {
  const { fromId, toId, floorName } = params;
  const floor = floorName ? `${floorName}/` : ``;
  return `/${path}/${fromId || `-`}/${toId || `-`}/${floor}`;
};
